/*
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const NatObj = require('../types/NatObj')
const kernel = require('../kernel/kernel')
const CElementGraphique = require('./CElementGraphique')
const CPointBase = require('./CPointBase')
const CSousListeObjets = require('./CSousListeObjets')
module.exports = CLieuDiscretDeBase

/**
 * Classe ancêtre de tous les lieux discrets (non reliés)
 * @constructor
 * @extends CElementGraphique
 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
 * @param {CImplementationProto} impProto : null ou la liste propriétaire.
 * @param {Boolean} estElementFinal : true si élément final de construction.
 * @param {mtg32.Couleur} couleur : La couleur de l'objet.
 * @param {Booelan} masque : true si l'objet est masqué
 * @param {CPt} pointATracer : Le point qui laisse une trace.
 * @param {Integer} nombreDePoints : Le nombre de points du lieu
 * @param {mtg32.MotfiPoint} motif : Le motif utilisé pour la trace des points.
 * @returns {CLieuDiscretDeBase}
 */
function CLieuDiscretDeBase (listeProprietaire, impProto, estElementFinal, couleur, masque,
  pointATracer, nombreDePoints, motif) {
  if (arguments.length !== 0) {
    if (arguments.length === 1) CElementGraphique.call(this, listeProprietaire);
    else {
      CElementGraphique.call(this, listeProprietaire, impProto, estElementFinal, couleur,
        true, 0, 0, masque, "", 16);
      this.pointATracer = pointATracer;
      this.nombreDePoints = nombreDePoints;
      this.motif = motif;
      this.abscissesCoordonneesPoints = new Array(nombreDePoints);
      this.ordonneesCoordonneesPoints = new Array(nombreDePoints);
      // Il faut créer la liste des éléments dont dépend le point à tracer
      this.listeElementsAncetres = new CSousListeObjets();
    }
    this.point1 = new CPointBase(listeProprietaire);
    this.point1.donneMotif(motif);
  }
}
CLieuDiscretDeBase.prototype = new CElementGraphique();
CLieuDiscretDeBase.prototype.constructor = CLieuDiscretDeBase;
CLieuDiscretDeBase.prototype.superClass = "CElementGraphique";
CLieuDiscretDeBase.prototype.className = "CLieuDiscretDeBase";
/**
 * Fonction chanheant les caractéristiques du lieu
 * @returns {undefined}
 */
CLieuDiscretDeBase.prototype.setClone = function(ptel) {
  CElementGraphique.prototype.setClone.call(this, ptel);
  this.motif = ptel.motif;
  this.indiceDernierPointTrace = ptel.indiceDernierPointTrace;
  // Il faut copier toutes les coordonnées
  for (var i = 0; i < this.indiceDernierPointTrace; i ++){
    this.abscissesCoordonneesPoints[i] = ptel.abscissesCoordonneesPoints[i];
    this.ordonneesCoordonneesPoints[i] = ptel.ordonneesCoordonneesPoints[i];
  }
};
CLieuDiscretDeBase.prototype.dependDe = function(p) {
  return CElementGraphique.prototype.dependDe.call(this, p) || this.pointATracer.dependDe(p);
};
CLieuDiscretDeBase.prototype.createg = function() {
  var g;
  this.point1.donneMotif(this.motif);
  this.point1.donneCouleur(this.couleur);
  g = kernel.cens("g",{
    "pointer-events" : "none"
  });
  for (var i = 0; i <= this.indiceDernierPointTrace; i ++)
  {
    this.point1.placeEn(this.abscissesCoordonneesPoints[i],this.ordonneesCoordonneesPoints[i]);
    g.appendChild(this.point1.createg());
  }
  return g;
};
CLieuDiscretDeBase.prototype.trace = function(svg, couleurFond, transparence) {
  var g = this.createg();
  g.setAttribute("id",this.id);
  svg.appendChild(g);
  this.g = g;
};
CLieuDiscretDeBase.prototype.update = function(svg) {
  var oldg = this.g;
  var g = this.createg();
  svg.replaceChild(g, oldg);
  g.setAttribute("id",this.id);
  this.g = g;
};
CLieuDiscretDeBase.prototype.dansFen = function(dimfen) {
  if (!this.existe) return false;
  var resultat = false;
  for (var i = 0;i <= this.indiceDernierPointTrace;i ++){
    resultat = resultat || dimfen.dansFenetre(this.abscissesCoordonneesPoints[i], this.ordonneesCoordonneesPoints[i]);
  }
  return resultat;
};
CLieuDiscretDeBase.prototype.remplacePoint = function(ancienPoint, nouveauPoint) {
  if (this.pointATracer=== ancienPoint) this.pointATracer = nouveauPoint;
};
CLieuDiscretDeBase.prototype.getNature = function() {
  return NatObj.NLieuDiscret;
};
CLieuDiscretDeBase.prototype.chaineDesignation = function() {
  return "desLieuPoint";
};
CLieuDiscretDeBase.prototype.read = function(inps, list){
  CElementGraphique.prototype.read.call(this, inps, list);
  this.point1 = new CPointBase(null);
  var ind1 = inps.readInt();
  this.pointATracer = list.get(ind1,"CPt.class");
  this.nombreDePoints = inps.readInt();
  this.motif = inps.readByte();
  // Il faut créer les tableaux de coordonnées
  // On réserve une coordonnée supplémentaire pour le cas d'un lieu fermé
  this.abscissesCoordonneesPoints = new Array(this.nombreDePoints);
  this.ordonneesCoordonneesPoints = new Array(this.nombreDePoints);
  this.listeElementsAncetres = new CSousListeObjets();
};
CLieuDiscretDeBase.prototype.write = function(oups, list){
  CElementGraphique.prototype.write.call(this, oups, list);
  var ind1 = list.indexOf(this.pointATracer);
  oups.writeInt(ind1);
  oups.writeInt(this.nombreDePoints);
  oups.writeByte(this.motif);
};



// WEBPACK FOOTER //
// ./src/objets/CLieuDiscretDeBase.js